import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const BaseIngredientScalingFactorCard = ({
	state,
	handlers,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-scaling-factor-card"
			title={t('baseIngredient:SCALING_FACTOR')}
			content={
				<>
					<div className="card-body">
						<RoundedInput
							disabled={!isBaseIngredientEditor}
							error-key="ScalingFactor"
							handleChange={handlers.setScalingFactor}
							name="scalingFactor"
							value={state.scalingFactor ?? 0}
						/>
					</div>
				</>
			}
		/>
	);
};
